import { render, staticRenderFns } from "./WaterDetail.vue?vue&type=template&id=138b340e&scoped=true&"
import script from "./WaterDetail.vue?vue&type=script&lang=js&"
export * from "./WaterDetail.vue?vue&type=script&lang=js&"
import style0 from "./WaterDetail.vue?vue&type=style&index=0&id=138b340e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138b340e",
  null
  
)

export default component.exports